<template lang="pug">
v-dialog(v-model='dialog' persistent max-width='600px')
  v-card
    v-card-title Add New Option
    v-card-text
      v-container
        v-row
          v-col(cols="12")
            v-select(v-model="form.provider" :items="providers" label="Provider")
            v-text-field(v-model="form.title" label="Title")
            v-text-field(v-model="form.sell_price" label="Sell Price" prefix="RM" type="number" step="0.01")
            v-text-field(v-model="form.cost_price" label="Cost Price" prefix="RM" type="number" step="0.01")
            v-text-field(v-model="form.normal_price" label="Normal Price" prefix="RM" type="number" step="0.01")
    v-card-actions
      v-spacer
      v-btn(text @click="dialog = false") Cancel
      v-btn.mr-4(color="primary" @click='add') Add
</template>

<script>

export default {
  name: "AddOptionDialog",
  props: ['value', 'productId'],
  data: (vm) => ({
    dialog: false,
    providers: [
      { text: 'ARBA Travel', value: 'ARBA'},
      // { text: 'Cebu Travel', value: 'CBTV'},
      // { text: 'Global Tix', value: 'GBTX'},
      // { text: 'Klook', value: 'KLOK'},
      // { text: 'Nanta', value: 'NNTA'},
      // { text: 'Onvacay', value: 'ONVC'},
      // { text: 'PlaceM', value: 'PLCM'},
      // { text: 'TCRT', value: 'TCRT'},
      // { text: 'BeMyGuest', value: 'BMGS'},
      { text: 'Marketplace API', value: 'MPLC'},
      // { text: '-', value: '-'},
    ],
    form: {
      provider: 'ARBA',
      product: vm.productId,
      title: '',
      sell_price: null,
      cost_price: null,
      normal_price: null,
      locale: 1
    }
  }),
  watch: {
    value (val) {
      this.dialog = val
    },
    dialog (val) {
      this.$emit('input', val)
    },
    productId (val) {
      this.form.product = val
    }
  },
  methods: {
    add () {
      const submitForm = { ...this.form }
      submitForm.sell_price = submitForm.sell_price * 100
      submitForm.cost_price = submitForm.cost_price * 100
      submitForm.normal_price = submitForm.normal_price * 100
      this.$axios.post(`/options/`, submitForm)
        .then(resp => {
          if (resp.data.id) {
            this.dialog = false
            this.$alert.success('Add Option Successful!')
            location.reload()
          } else {
            this.$alert.failed('Add Option Failed!')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>